export default __webpack_public_path__ + "static/media/ban-desktop-image-5.ca4dec99.jpg";